var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000046",
    d: "m10.05 15.53 8.777-8.776q.24-.247.569-.256a.8.8 0 0 1 .595.25q.265.261.265.582 0 .322-.265.587l-9.15 9.15a1.07 1.07 0 0 1-.789.343q-.45 0-.792-.343l-4.2-4.2a.8.8 0 0 1-.253-.569.8.8 0 0 1 .253-.594q.261-.266.582-.266t.587.266z"
  })));
};
export default SvgCheck;